import { t } from "../../i18n";
import { DateField } from "../DateField";
import { WINDOWS } from "../../lib/checkoutHelpers";

export const DateWindowFields = ({ locale, idx, g, minDate, windowSelectable, updateGift }) => (
  <div className="grid sm:grid-cols-2 gap-4 items-end">
    <div className="space-y-1">
      <label className="smallcaps">{t(locale, "deliveryDate")}</label>
      <DateField testid={`delivery-date-${idx}`} min={minDate} value={g.delivery_date}
                 onChange={(v) => updateGift(g.gift_id, { delivery_date: v })} />
    </div>
    <div className="space-y-1">
      <label className="smallcaps">{t(locale, "deliveryWindowLabel")}</label>
      <select className="field" data-testid={`delivery-window-${idx}`} value={g.delivery_window}
              onChange={(e) => updateGift(g.gift_id, { delivery_window: e.target.value })}>
        {WINDOWS.map((w) => {
          const disabled = !windowSelectable(g, w);
          return <option key={w} value={w} disabled={disabled}>{`${t(locale, w)}${disabled ? ` — ${t(locale, "closed")}` : ""}`}</option>;
        })}
      </select>
    </div>
  </div>
);

export const CardMessage = ({ locale, idx, g, updateGift }) => (
  <div className="space-y-1">
    <label className="smallcaps">{t(locale, "giftCard")}</label>
    <textarea data-testid={`card-message-${idx}`} className="field h-20" maxLength={220}
              value={g.card_message || ""} onChange={(e) => updateGift(g.gift_id, { card_message: e.target.value })} />
    <p className="text-xs text-muted">{220 - (g.card_message || "").length} {t(locale, "charsLeft")} · {g.is_anonymous ? t(locale, "anonymous") : g.sender_name}</p>
  </div>
);

export const CallPreference = ({ locale, idx, r, set }) => {
  const noAddress = r.knows_address === false;
  return (
    <div className="space-y-1 text-sm">
      <label className="flex items-start gap-2">
        <input data-testid={`call-before-radio-${idx}`} type="radio" checked={r.call_before_delivery}
               onChange={() => set("call_before_delivery", true)} className="mt-1" />
        <span>{t(locale, "callBefore")} <span className="text-muted">— {t(locale, "callBeforeHelp")}</span></span>
      </label>
      <label className={`flex items-start gap-2 ${noAddress ? "opacity-40 cursor-not-allowed" : ""}`}>
        <input data-testid={`surprise-radio-${idx}`} type="radio" checked={!r.call_before_delivery} disabled={noAddress}
               onChange={() => set("call_before_delivery", false)} className="mt-1" />
        <span>{t(locale, "surprise")} <span className="text-muted">— {t(locale, "surpriseHelp")}</span></span>
      </label>
      {noAddress ? <p className="text-xs text-muted" data-testid={`call-required-note-${idx}`}>{t(locale, "callRequiredNote")}</p> : null}
    </div>
  );
};
